import { startCase } from 'lodash-es'

import {
  IGroupColumnType,
  useGetGroupColumnsDataQuery
} from 'app/services/api/qra/groupColumns'
import { IGroupColumnsSelection } from 'features/RiskManagement/Components/Tables'

interface IGroupColumnsProps {
  groupColumns: IGroupColumnsSelection[]
  setGroupColumns: (groupColumns: IGroupColumnsSelection[]) => void
}

interface ICategorySelectButton extends IGroupColumnsProps {
  groupColumnsCategories: IGroupColumnType[]
}

const GroupColumns = ({
  groupColumns,
  setGroupColumns
}: IGroupColumnsProps) => {
  const { currentData = [] } = useGetGroupColumnsDataQuery()

  return (
    <CategorySelectButtons
      groupColumns={groupColumns}
      setGroupColumns={setGroupColumns}
      groupColumnsCategories={currentData}
    />
  )
}

// #region Single Category Selection Buttons
/**
 * The oval buttons for single category selection
 * TODO: Wire up to pull category from table attributes API
 */
const CategorySelectButtons = ({
  groupColumns,
  groupColumnsCategories,
  setGroupColumns
}: ICategorySelectButton) => {
  const selectCategory = (category: string, categoryId: number) => {
    setGroupColumns([
      {
        id: categoryId,
        name: category,
        groupTypeColumns: undefined
      }
    ])
  }

  return (
    <>
      {groupColumnsCategories?.map((category) => {
        return (
          <CategoryButton
            key={category.id}
            category={startCase(category.name)}
            selectedCategories={groupColumns.map((gc) => gc.name)}
            onClick={() => selectCategory(category.name, category.id)}
          />
        )
      })}
    </>
  )
}

interface ICategoryButton {
  category: string
  selectedCategories: string[]
  onClick: () => void
}

const CategoryButton = ({
  category,
  selectedCategories,
  onClick
}: ICategoryButton) => {
  const baseClasses = [
    'mx-1 px-4 py-2',
    'border rounded',
    'font-medium',
    'leading-none tracking-[0.01em]'
  ].join(' ')

  const activeClasses = [baseClasses, 'bg-lighthouseBlue', 'text-white'].join(
    ' '
  )

  const inactiveClasses = [
    baseClasses,
    'border-lighthouseBlue',
    'text-lighthouseBlue'
  ].join(' ')

  return (
    <button
      className={
        selectedCategories.includes(category.replace(/ /g, ''))
          ? activeClasses
          : inactiveClasses
      }
      onClick={onClick}
    >
      {category}
    </button>
  )
}

export default GroupColumns
